import React, { Component } from "react";
import moment from "moment";
import { forEach } from "underscore";
import { Link } from "react-router-dom";
import ImageCarousel from "./common/imageCarousel";

class EventCard extends Component {
  state = {
    currentPhotoIndex: 0,
  };

  render() {

    // const { currentPhotoIndex } = this.state;
    
    const { event, currentUser } = this.props;
    const defaultPhotoURI =
      "https://events-fs.s3.amazonaws.com/assets/default_event_photo.jpg";

    let address = event.address.country +
      " . " + event.address.province +
      " . " + event.address.town 
      
    if (event.address.streetAddress) address += " . " + event.address.streetAddress;


    let contacts = "";
    let i;
    
    if(event.owner && event.contacts.length > 0) contacts += " . "
    
    for (i = 0; i < event.contacts.length; i++) {
      contacts += event.contacts[i];
      if (i < event.contacts.length - 1) contacts += " . ";
    }
    

    const ownEvent = currentUser? event.uid === currentUser._id && !event.adminGen: false;    
    const adminPermission = currentUser? event.adminGen && currentUser.isAdmin: false; 


    return (
      <div className="card w-100 mb-3 shadow" style={{maxWidth: 550}}>

        <div className="card-body">
          <h5 className="float-right ml-3 mb-2">
            {event.types.map((type) => (
              <span key={type}>
                <span className="badge badge-dark">{type}</span>
                &nbsp;
              </span>
            ))}
          </h5>
          
          <h5 className="card-title">
            <b>{event.active? event.title: event.title + " - DELETED"} </b>
            {" "}
            {ownEvent || adminPermission ?
            <Link 
              to={{
                pathname:`/events/form/${event._id}`,
                state: {id:event._id}
              }}>
                <span className="badge badge-primary">Edit</span></Link>:null}
          </h5>
          
          <span>
            {event.omitTime
              ? moment(event.dateTime).format("YYYY/MM/DD") 
              : moment(event.dateTime).format("YYYY/MM/DD") + " . " 
              + moment(event.dateTime).format("HH:mm")
            }
          </span>

          <br />
          <span>
            {address}
          </span>
          <br />
          <span> <b>{event.owner}</b> <i>{contacts}</i> </span>
          
        </div>
        
        <ImageCarousel
          interval = {5000}
          imageList = {event.photoURIs[0]
            ? event.photoURIs
            : [defaultPhotoURI]}
        />

        <div className="card-body">
          <p className="card-text" style={{ whiteSpace: "break-spaces" }}>{event.details}</p>
        </div>
      </div>
    );
  }
}

export default EventCard;
